import { Link } from 'react-router-dom';

export default function AccessDeniedPage() {
  return (
    <div className="login-page">
      <div className="login-card card">
        <h1>Access denied</h1>
        <p>Your Google account is not on the Lion Canvas allowlist.</p>
        <p className="muted">Contact your administrator to request access.</p>
        <Link to="/login" className="btn">Back to login</Link>
      </div>
    </div>
  );
}
